import { useParams } from "react-router-dom";
import Lang from '../Lang';


export default function ImageDownloaderPrivacyPolicy(props){

const {language} = useParams();
    let lang = language;
    document.title = "Image downloader-privacy policy";
const translation = {
    "en": [
        "Image Downloader Extension Privacy Policy",
        "We do not collect user data."
    ],
    "fr": [
        "Politique de confidentialité de l’extension Image Downloader",
        "Nous ne collectons pas les données des utilisateurs."
    ],
    "es": [
        "Política de privacidad de la extensión Image Downloader",
        "No recopilamos datos de los usuarios."
    ],
    "pt": [
        "Política de privacidade da extensão Image Downloader",
        "Não coletamos dados dos usuários."
    ],
    "de": [
        "Datenschutzerklärung der Image Downloader-Erweiterung",
        "Wir sammeln keine Benutzerdaten."
    ],
    "it": [
        "Informativa sulla privacy dell'estensione Image Downloader",
        "Non raccogliamo i dati degli utenti."
    ],
    "hu": [
        "Az Image Downloader bővítmény adatvédelmi irányelvei",
        "Nem gyűjtünk felhasználói adatokat."
    ],
    "he": [
        "מדיניות הפרטיות של תוסף Image Downloader",
        "איננו אוספים נתוני משתמשים."
    ],
    "tr": [
        "Image Downloader uzantısının gizlilik politikası",
        "Kullanıcı verilerini toplamıyoruz."
    ],
    "ru": [
        "Политика конфиденциальности расширения Image Downloader",
        "Мы не собираем данные пользователей."
    ],
    "ko": [
        "Image Downloader 확장 프로그램 개인정보 보호정책",
        "사용자 데이터를 수집하지 않습니다."
    ],
    "vi": [
        "Chính sách quyền riêng tư của tiện ích Image Downloader",
        "Chúng tôi không thu thập dữ liệu người dùng."
    ],
    "th": [
        "นโยบายความเป็นส่วนตัวของส่วนขยาย Image Downloader",
        "เราไม่เก็บรวบรวมข้อมูลผู้ใช้"
    ],
    "ja": [
        "Image Downloader 拡張機能のプライバシーポリシー",
        "ユーザーデータを収集しません。"
    ],
    "zh_CN": [
        "Image Downloader 扩展程序隐私政策",
        "我们不会收集用户数据。"
    ],
    "zh_TW": [
        "Image Downloader 擴充功能隱私政策",
        "我們不會收集使用者資料。"
    ]
};
  
    return(

        <div style={{color:"white",direction: lang != 'he' ? 'ltr' : 'rtl'}}>
                <Lang />
       <br/><br/><br/><br/>
       <p>
<h1>
  <u>
{translation[lang][0]}
</u>
</h1>
</p>
<br />
{translation[lang][1]}
        </div>
        )
}